"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveUsersPopover = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const AbstractHelpPopover_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/help/AbstractHelpPopover");
const ActiveUsersPopover = () => {
    const content = React.createElement("div", { style: { width: "400px" } },
        React.createElement("p", null,
            "Active users are counted based on the ",
            React.createElement(antd_1.Typography.Text, { code: true }, "Principal"),
            "."),
        React.createElement("p", null, "Weekly Active Users are those who\u2019ve been active at least one time in the last 7 days and Monthly Active Users are those who\u2019ve been active at least one time in the last 30 days."));
    return React.createElement(AbstractHelpPopover_1.AbstractHelpPopover, { title: "Active users", content: content });
};
exports.ActiveUsersPopover = ActiveUsersPopover;
